// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from "vuex"
import App from './App'
import router from './router'
/**引入加载进度条 */
import NProgress from "nprogress"
import "nprogress/nprogress.css"  // 这个样式必须引入
/**引入elementUI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
/**引入vuex */
import store from './store'
/**全局过滤器 */
import * as filters from '@/utils/filters'
/**使用彩色图标 */
import '@/style/fonts/iconfont.js'
import i18n from "./i18n/index";
import VueLazyload from 'vue-lazyload';

Vue.config.productionTip = false
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(Vuex);



/**进度条配置 */
NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false
});

//全局注册过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

//注册事件广播
Vue.use({
  install: function (Vue) {
      Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();
  }
});

const errorimage = require('./assets/profileSetting.png')

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  error: errorimage
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js